import {
    EventSeatSmallDto,
    PagedResultOfReservationDto,
    PublicCancelEventReservationModel,
    PublicCancelSubscriptionReservationModel,
    PublicCreateEventReservationModel,
    PublicCreateSubscriptionReservationModel,
    PublicUpdateEventReservationModel,
    PublicUpdateSubscriptionReservationModel, Reservation,
    ReservationDto,
    ReservationsApi, ReservationSeatStatusDto,
    SeatConfigurationDto,
    SubscriptionSeatSmallDto
} from "../../api";
import {AxiosResponse} from "axios";

export class SeatReservationService{
    private _reservationApi!: ReservationsApi;
    private _id: number;
    private _mode: ReservationMode;

    constructor(reservationApi: ReservationsApi, id: number, mode: ReservationMode ) {
        this._reservationApi = reservationApi;
        this._id = id;
        this._mode = mode;
    }

    async getCustomerReservations( ): Promise<ReservationDto[]>{
        let all: ReservationDto[] = [];
        try {
            let pagedResult: PagedResultOfReservationDto;
            let page = 1;
            let pageSize = 400;

            do {
                let response: AxiosResponse<PagedResultOfReservationDto>;

                switch (this._mode) {
                    case ReservationMode.EventMode:
                        response = await this._reservationApi.reservationsGetEventReservations(this._id, page, pageSize);
                        break;
                    case ReservationMode.SubscriptionMode:
                        response = await this._reservationApi.reservationsGetSubscriptionReservations(this._id, page, pageSize);
                        break;
                }
                
                pagedResult = response.data;
                if (pagedResult && pagedResult.results != undefined) {
                    all.push(...pagedResult.results)
                }
                page++;
            } while (pagedResult && pagedResult.hasMorePages)
        } catch (error) {
            console.error(error);
        }
        
        return all;
    }

    async getReservations(id: number) {
        if (this._mode === ReservationMode.EventMode) {
            return this.getEventReservations(id);
        } else if (this._mode === ReservationMode.SubscriptionMode) {
            return this.getSubscriptionReservations(id);
        }
        throw new RangeError();
    }

    async getEventReservations(eventId: number): Promise<Array<ReservationSeatStatusDto>> {
        let response =   await this._reservationApi.reservationsGetReservedSeatsForEvent(eventId);
        return response.data.results?? [];
    }


    async getSubscriptionReservations(subscriptionId: number): Promise<Array<ReservationSeatStatusDto>> {
        let response =   await this._reservationApi.reservationsGetReservedSeatsForSubscription(subscriptionId);
        return response.data.results?? [];
    }

    public async createPendingReservation(seat: EventSeatSmallDto | SubscriptionSeatSmallDto, priceConfig: SeatConfigurationDto, onError: () => void): Promise<Reservation | undefined> {
        switch (this._mode) {
            case ReservationMode.EventMode:
                return await this.createPendingEventReservation(seat, priceConfig, onError);
            case ReservationMode.SubscriptionMode:
                return await this.createPendingSubscriptionReservation(seat, priceConfig, onError);
        }
    }

    public async createPendingEventReservation(seat: EventSeatSmallDto, priceConfig: SeatConfigurationDto, onError: () => void): Promise<Reservation | undefined> {
        try {

            let requestModel = <PublicCreateEventReservationModel>{
                eventId: this._id,
                seatCode: seat?.code,
                priceId: priceConfig.prices?.[0].id
            };

            const response = await this._reservationApi.reservationsCreateForEvent(requestModel);

            if (!response || !response.data) {
                onError();
                return undefined;
            }

            return response.data
        } catch (error) {
            console.error(error);
            onError();
            return undefined;
        }
    }

    public async createPendingSubscriptionReservation(seat: SubscriptionSeatSmallDto, priceConfig: SeatConfigurationDto, onError: () => void): Promise<Reservation | undefined> {
        try {

            let requestModel = <PublicCreateSubscriptionReservationModel>{
                subscriptionId: this._id,
                SeatCode: seat?.code,
                PriceId: priceConfig.prices?.[0].id
            };

            const response = await this._reservationApi.reservationsCreateForSubscription(requestModel);

            if (!response || !response.data) {
                onError();
                return undefined;
            }

            return response.data
        } catch (error) {
            onError();
            return undefined;
        }
    }

    public async cancelPendingEventReservation(reservationId: number) {
        if (this._mode != ReservationMode.EventMode){
            return;
        }
        
        let request = <PublicCancelEventReservationModel>{
            reservationId: reservationId
        }
        let response = await this._reservationApi.reservationsCancelEventReservation(request);
        return response.data;
    }
    
    public async cancelPendingSubscriptionReservation(subscriptionId: number, seatCode: string) {
        if (this._mode != ReservationMode.SubscriptionMode){
            return;
        }
        
        let request = <PublicCancelSubscriptionReservationModel>{
            subscriptionId: subscriptionId,
            seatCode: seatCode
        }
        let response = await this._reservationApi.reservationsCancelSubscriptionReservation(request);
        return response.data;
    }

    public async updatEventReservation(request: PublicUpdateEventReservationModel[]){
        if (this._mode != ReservationMode.EventMode){
            return;
        }
        await this._reservationApi.reservationsChangeEventReservations(request);
    }
    
    public async updateSubscriptionReservation(request: PublicUpdateSubscriptionReservationModel[]){
        if (this._mode != ReservationMode.SubscriptionMode){
            return;
        }
        
        await this._reservationApi.reservationsChangeSubscriptionReservations(request);
    }


}